import React from "react";
import type { ApolloClient } from "@apollo/client";
import { connect, type ConnectedProps } from "react-redux";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";
import { toast } from "react-toastify";

import SimpleModal from "components/SimpleModal";
import { createErrorSelector, createLoadingSelector } from "store/selectors";
import { restartWorkflow } from "actions/adminActions";
import { adminConstants } from "actions/types";
import type { RootState } from "types/state";

const isFetchingSelector = createLoadingSelector(
  adminConstants.RESTART_WORKFLOW
);
const errorSelector = createErrorSelector(adminConstants.RESTART_WORKFLOW);

const mapStateToProps = (state: RootState) => {
  return {
    isFetching: isFetchingSelector(state),
    error: errorSelector(state),
  };
};

const mapDispatchToProps = {
  restartWorkflow,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

interface OwnProps {
  onClose: (clickingOutsideModal?: boolean) => void;
  onSuccess: () => void;
  workflow: { id?: string; name?: string };
}

type Props = WithApolloClient<OwnProps & PropsFromRedux>;

class RestartWorkflowModal extends React.PureComponent<Props> {
  _restartWorkflow = () => {
    void this.props
      .restartWorkflow(
        this.props.client as ApolloClient<object>,
        this.props.workflow.id as string
      )
      .then((result) => {
        if (result.success) {
          this.props.onSuccess();
          toast.success("Successfully restarted workflow.");
        }
      });
  };

  render() {
    return (
      <SimpleModal
        show={true}
        onClose={this.props.onClose}
        onSubmit={this._restartWorkflow}
        title="Restart Workflow"
        buttonText="Restart"
        closeButtonText="Cancel"
        showCloseButton={true}
        isXhrRequest={true}
        error={this.props.error}
        isFetching={this.props.isFetching}
      >
        <p>
          {"Are you sure you want to restart "}
          <b>{this.props.workflow.name}</b>
          {` (${this.props.workflow.id})?`}
        </p>
        <p>{"The failed step will be retried on the next workflow run."}</p>
      </SimpleModal>
    );
  }
}

export default connector(withApollo<Props>(RestartWorkflowModal));
